// extracted by mini-css-extract-plugin
export default {"textarea-element":"TextArea_textarea-element__LfOlq"};